module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_iron-891c1a4aa8110e82c745cbae72ace4bf.png";